import { useEffect, useState } from "react";

export function useGetDeviceInfo() {
  const [redirectUrl, setRedirectUrl] = useState("/");
  const [deviceType, setDeviceType] = useState("WEB");

  useEffect(() => {
    if (typeof window !== "undefined" && navigator) {
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        setRedirectUrl("https://apps.apple.com/gb/app/onmo/id6498719371");
        setDeviceType("IOS");
      } else {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

        if (isAndroid) {
          setRedirectUrl(
            "https://play.google.com/store/apps/details?id=app.onmo.v2&gl=UK",
          );
          setDeviceType("ANDROID");
        }
      }
    }
  }, []);

  return {
    deviceType,
    redirectUrl,
  };
}
